import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seclab-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  menuItems: Array<string> = [
    'Página Inicial',
    'Sobre Nós',
    'Serviços',
    'Contato',
  ];

  constructor() {}

  ngOnInit(): void {}
}
